import { createGlobalStore } from 'hox'
import { useEffect, useState } from 'react'
import { setLanguage } from '@/i18n/lang'
import { SizeChangeCBArgs } from '@/utils/reponsive'

export const [useGlobalStore, getGlobalStore] = createGlobalStore(() => {
  const [curLanguage, setCurLanguage] = useState<string>('en_US')
  const [curReponsive, setCurReponsive] = useState<SizeChangeCBArgs>()

  /**
   * 切换语言
   * @param lang
   */
  const handleCheckLanguage = (lang: string) => {
    setCurLanguage(lang)
    setLanguage(lang)
    console.log('lang4', lang)
    localStorage.setItem('language', lang)
  }

  useEffect(() => {
    let local_lang = localStorage.getItem('language')
    if (!local_lang) {
      let nav_lang = navigator.language
      console.log('nav_lang', nav_lang)
      if (navigator.language) {
        // 韩语
        if (navigator.language.startsWith('ko')) {
          // 映射为朝鲜语
          nav_lang = 'ko_KP'
        }
        // 中文简体
        else if (navigator.language.startsWith('zh-CN')) {
          nav_lang = 'zh-TW'
        }
        // 英语
        else if (navigator.language.startsWith('en')) {
          nav_lang = 'en_US'
        }
        // 越南语
        else if (navigator.language.startsWith('vi')) {
          nav_lang = 'vi-VN'
        }
        // 泰语
        else if (navigator.language.startsWith('th')) {
          nav_lang = 'th-TH'
        }
        // 土耳其语
        else if (navigator.language.startsWith('tr')) {
          nav_lang = 'tr-TR'
        }
        // 西班牙语
        else if (navigator.language.startsWith('es')) {
          nav_lang = 'es-ES'
        }
        // 葡萄牙语
        else if (navigator.language.startsWith('pt')) {
          nav_lang = 'pt-PT'
        } else {
          local_lang = 'en_US'
        }
        // 没有韩语和日语？
        local_lang = nav_lang.replace('-', '_')
      } else {
        local_lang = 'en_US'
      }
    }
    setLanguage(local_lang)
    setCurLanguage(local_lang)
  }, [])

  return {
    curLanguage,
    handleCheckLanguage,
    curReponsive,
    setCurReponsive,
  }
})
